import { createSelector } from 'reselect'

const getCommunicationSummary = (state: any) => state.votesDetails

/** A Redux selector to retrieve Votes count
 * @param state - The Redux state
 * @param {Boolean} - Numerical value indicating votes count.
 */

export const selectVotesDetails = createSelector(
  getCommunicationSummary,
  (data) => data && data.voteCount ? data.voteCount : 0
)